import { pushBackFrame } from '@/composables/useBackState';

/**
 * Сохраняет кадр перед переходом: pageData восстанавливается по fromPageName.
 */
export const savePageBackState = (
    fromPath: string,
    fromPageName: string,
    pageData: Record<string, unknown>,
) => {
    pushBackFrame({ fromPath, fromPageName, pageData });
};

/** Кадр без pageData — только возврат по fromPath (safety, notifications). */
export const saveSimpleBackState = (fromPath: string, fromPageName: string) => {
    pushBackFrame({ fromPath, fromPageName });
};
